import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from 'app/global/global.service';
import { AuthenticationTypeEnum } from 'app/main/signing-pages/enums/enum';
import { Personfield } from '../../edit-template.dto';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input-gg';
import { HelperService } from '../../helper.service';
@Component({
  selector: 'app-active-role-fields',
  templateUrl: './active-role-fields.component.html',
  styleUrl: './active-role-fields.component.scss'
})
export class ActiveRoleFieldsComponent implements OnInit, OnDestroy {
  @Input() form!: FormGroup;
  @Input() get enableFields(): boolean {
    return this.enableRoleFeilds;
  }
  set enableFields(value: boolean) {
    this.enableRoleFeilds = value || false;
  }
  public enableRoleFeilds: boolean = false;
  private timeoutId?: ReturnType<typeof setTimeout>;
  private authenticationTypeEnum = AuthenticationTypeEnum;
  public SearchCountryField = SearchCountryField;
  public CountryISO = CountryISO;
  constructor(private globalService:GlobalService, private helperService: HelperService) { }

  ngOnInit(): void {
    this.timeoutId = setTimeout(() => {
      if (this.enableRoleFeilds) {
        this.template_roles.value.forEach((td, ti) => {
          const role = this.template_roles.at(ti);
          td.personfields.forEach((item:Personfield, itemIndex) => {
            const control = role.get(`personfields.${itemIndex}.value`);
            if(role.get(`personfields.${itemIndex}.key`).value === 'first_name'){
              const findLastName = td?.personfields.findIndex((field) => field.key === 'last_name');
              const lastNameLockControl = role.get(`personfields.${findLastName}.lock`);
              const lastNameControl = role.get(`personfields.${findLastName}.value`);
              lastNameLockControl.patchValue(item?.lock);
              lastNameControl.updateValueAndValidity();
              if (lastNameControl && item?.lock) {
                lastNameControl.disable();
              }
            }
            if (control && item?.lock && item.key !== 'last_name') {
              control.disable();
            }
            if(role.get('authentication_type').value === this.authenticationTypeEnum.BANKID && item.key === 'personal_id_number'){
              const enableFieldControl = role.get(`personfields.${itemIndex}.is_enable`);
              enableFieldControl.setValue(1);
              control.setValidators(this.setPersonalNumberValidation(item));
              control.updateValueAndValidity();
            }
          });
          td.orgfields.forEach((item, itemIndex) => {
            const control = role.get(`orgfields.${itemIndex}.value`);
            if (control && item?.lock) {
              control.disable();
            }
          });
        });
      }
    }, 500)
  }

  private setPersonalNumberValidation(person_field:Personfield){
    let validationArray = [];
    if(person_field?.required === 1 && person_field?.validation === 1){
      validationArray = [Validators.required, this.globalService.createpPersonnummerValidator()];
    } 
    else if(person_field?.required){
      validationArray = [Validators.required];
    }
    else if(person_field?.validation){
      validationArray = [this.globalService.createpPersonnummerValidator()];
    }

    return validationArray;
  }

  /** Get form controls */
  get template_roles() {
    return this.form?.get('template_roles') as FormArray;
  }

  /**
   * Get person fields
   * @access
   */
  get personfields() {
    return this.template_roles.controls["personfields"] as FormArray;
  }



  /**
   * Get organizations fields
   * @access
   */
  get orgfields() {
    return this.template_roles.controls["orgfields"] as FormArray;
  }

  onCountrySelected($event: { iso2?: string }, personfieldsForm: FormGroup) {
    this.helperService.updateTheLandCode($event, personfieldsForm);
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutId);
  }

}
